import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import FileSaver from 'file-saver'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import RegulationAutoExportRepository from '@/shared/http/repositories/regulation/auto/regulationautoexport.js'

import SinisterSearchData from '@/shared/models/regulation/auto/sinistersearchmodel.js'
import SinisterSearchForms from './sinistersearch-form'

import AccountMixin from '@/store/module/account/mixin'
import InsuranceMixin from '@/store/module/insurance/mixin.js'
import StageMixin from '@/store/module/stage/mixin.js'
import ExpertMixin from '@/store/module/expert/mixin.js'
import AnalystMixin from '@/store/module/analyst/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationTypeMixin from '@/store/module/regulationtype/mixin'
import SchedulingTypeMixin from '@/store/module/schedulingtype/mixin'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'
import ProductMixin from '@/store/module/product/mixin'

import { actionTypes as RegulationActions } from '@/store/module/regulation/actions'
import { globalMutationTypes as RegulationMutations } from '@/store/module/regulation/mutations'

window.FileSaver = FileSaver

export default {
  name: 'sinisterSearch',
  mixins: [
    ActionsForm,
    InsuranceMixin,
    StageMixin,
    ExpertMixin,
    AnalystMixin,
    RegulationMixin,
    AccountMixin,
    RegulationTypeMixin,
    SchedulingTypeMixin,
    BudgetSystemMixin,
    ProductMixin
  ],
  data () {
    return {
      data: SinisterSearchData,
      form: SinisterSearchForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Datepicker
  },
  mounted () {
    this.forceFlagExpert()
  },
  computed: {
    isAnalyst: function () {
      var result = false
      if (this.account) {
        result = this.account.isAnalyst
      }
      return result
    },
    regulatorID: {
      get () {
        if (!this.isRegulator) {
          return null
        }

        const expert = this.form.expert.options.filter(x => x.value === this.account.expertID)
        this.form.expert.value = expert
        return expert
      },
      set (value) {
        this.form.expert.value = value
      }
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.insurance.options = result
      }
      return result
    },
    getAllStage: function () {
      var result = []
      if ((this.stages) && (this.stages.count) > 0) {
        var data = this.stages.data
        for (var i in data) {
          if (data[i].status) {
            if (!this.isRegulator) {
              if (!this.isAnalyst) {
                result.push({ 'label': data[i].name, 'value': data[i].id })
              } else if (data[i].mnemonic === 'STG_ANALYSIS') {
                // PARA O ANALISTA SOMENTE EM ANÁLISE
                result.push({ 'label': data[i].name, 'value': data[i].id })
              }
            } else if (data[i].mnemonic === 'STG_REGULATION') {
              // PARA O PERITO SOMENTE EM REGULAÇÃO
              result.push({ 'label': data[i].name, 'value': data[i].id })
            }
          }
        }
        this.form.stage.options = result
      }
      return result
    },
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.expert.options = result
      }
      return result
    },
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.analyst.options = result
      }
      return result
    },
    getAllRegulationType: function () {
      var result = []
      if ((this.regulationtypes) && (this.regulationtypes.count) > 0) {
        var data = this.regulationtypes.data
        result = data.filter(d => d.status)
          .map(d => ({ 'label': d.name, 'value': d.id }))
        this.form.regulationType.options = result
      }
      return result
    },
    getAllSchedulingType: function () {
      var result = []
      if ((this.schedulingtypes) && (this.schedulingtypes.count) > 0) {
        var data = this.schedulingtypes.data
        result = data.filter(d => d.status)
          .map(d => ({ 'label': d.name, 'value': d.id }))
      }
      return result
    },
    getAllBudgetSystem: function () {
      var result = []
      if ((this.budgetsystems) && (this.budgetsystems.count) > 0) {
        var data = this.budgetsystems.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.budgetSystem.options = result
      }
      return result
    },
    getAllProduct: function () {
      var result = []
      if ((this.products) && (this.products.count) > 0) {
        var data = this.products.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.product.options = result
      }
      return result
    }
  },
  methods: {
    Clear () {
      this.onClear()
    },
    onClearAllTabs () {
      this.$store.commit(RegulationMutations.SET_REGULATION, {})
      this.$emit('ClearTabs', this.onClear)
      setTimeout(() => {
        this.$emit('MoveTabIndex')
      }, 400)
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.tableGrid.Clear(null)
      setTimeout(() => {
        this.forceFlagExpert()
      }, 400)
    },
    onLoad () {
      this.getAllInsuranceByArea(process.env.AreaAutos)
      this.getAllStageByArea(process.env.AreaAutos)
      this.getAllExpertByArea(process.env.AreaAutos)
      this.getAllRegulationTypeByArea(process.env.AreaAutos)
      this.getAllSchedulingTypes()
      this.getAllBudgetSystems()
      this.getAllAnalysts()
      this.getAllProducts()
    },
    onSearch () {
      var self = this
      self.$refs.frmSinister.OnEnableSearchButton()
      loading.push()
      if (Tools.ValidateForms(this.form, this.data, self)) {
        if (this.data.sinisterCode) {
          this.data.sinisterCode = this.data.sinisterCode.toString()
        }
        RegulationAutoRepository.Search(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.data)
          .then((response) => {
            this.onResultGrid(response)
            self.$refs.frmSinister.OnEnableSearchButton()
          })
          .catch((err) => {
            this.onException(err)
            self.$refs.frmSinister.OnEnableSearchButton()
          })
      }
    },
    onExport () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self)) {
        if (this.data.analyst !== null || this.data.expert !== null || this.data.insurance !== null || this.data.insured !== null || this.data.plate !== null ||
          this.data.ranking !== null || this.data.regulationType !== null || this.data.sinisterCode !== null || this.data.sinisterDateEnd !== null ||
          this.data.sinisterDateStart !== null || this.data.sinisterVersion !== null || this.data.stage !== null) {
          loading.push()
          RegulationAutoExportRepository.Export(this.data)
            .then(response => {
              var result = response.data
              if (result.code === 0) {
                const s2ab = (s) => {
                  var buf = new ArrayBuffer(s.length)
                  var view = new Uint8Array(buf)
                  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
                  return buf
                }
                const blob = new Blob([s2ab(atob(result.data.file))], { type: result.data.contentType })
                FileSaver.saveAs(blob, result.data.fileName)
              } else {
                var alertMessage = self.$lang.Common.Alerts.RequiredDate
                self.$refs.alert.ShowAlert('warning', alertMessage)
              }
              loading.pop()
            })
            .catch((err) => {
              this.onException(err)
            })
        } else {
          var alertMessage = self.$lang.Common.Alerts.RequiredDate
          self.$refs.alert.ShowAlert('warning', alertMessage)
          return false
        }
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
      this[RegulationActions.GET_BY_ID](obj.id)
        .then((response) => {
        })
    },
    onFullscreen () {
      if (this.$refs.frmSinister.showForm) {
        this.$refs.frmSinister.showForm = false
      } else {
        this.$refs.frmSinister.showForm = true
      }
    },
    forceFlagExpert () {
      if (this.isRegulator) {
        const expert = this.form.expert.options.filter(x => x.value === this.account.expertID)
        const stage = this.form.stage.options
        this.form.expert.value = expert
        this.form.stage.value = stage
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/search/sinistersearch.js